import { Form, Input, Select } from "antd";

const ZOHO_VIEW_LINK =
  /^https:\/\/analytics\.zoho\.[a-z.]+\/workspace\/\d+\/view\/\d+/i;

const getUrlFieldRules = (label) => [
  { type: "url", message: `${label} must be a valid url` },
  {
    pattern: ZOHO_VIEW_LINK,
    message: `${label} must be a link to a Zoho Analytics dashboard`,
  },
];

export const ReportConfigForm = ({
  form,
  onFinish,
  clients,
  disableClientSelection = false,
  defaultValues = {},
  onDirtyChange,
}) => {
  const values = {
    clientId: defaultValues?.clientId ?? null,
    recruiterProductivityReportLink:
      defaultValues?.recruiterProductivityReportLink ?? "",
    weeklyReportLink: defaultValues?.weeklyReportLink ?? "",
    monthlyReportLink: defaultValues?.monthlyReportLink ?? "",
    dashboardReportLink: defaultValues?.dashboardReportLink ?? "",
  };

  const handleFinish = (formValues) => {
    onFinish({
      ...formValues,
      recruiterProductivityReportLink:
        formValues.recruiterProductivityReportLink || null,
      weeklyReportLink: formValues.weeklyReportLink || null,
      monthlyReportLink: formValues.monthlyReportLink || null,
      dashboardReportLink: formValues.dashboardReportLink || null,
    });
  };

  const onValuesChange = (v, newValues) => {
    onDirtyChange?.(JSON.stringify(values) !== JSON.stringify(newValues));
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      onValuesChange={onValuesChange}
      initialValues={values}
    >
      <Form.Item
        required
        name="clientId"
        label="Client"
        rules={[{ required: true, message: "Client is required" }]}
      >
        <Select
          placeholder="Select Client"
          options={clients}
          disabled={disableClientSelection}
          showSearch
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
        />
      </Form.Item>
      <Form.Item
        name="recruiterProductivityReportLink"
        label="Recruiter Productivity Report Source"
        rules={getUrlFieldRules("Recruiter Productivity Report Source")}
      >
        <Input placeholder="Paste the Zoho Analytics dashboard link" />
      </Form.Item>
      <Form.Item
        name="weeklyReportLink"
        label="Weekly Report Source"
        rules={getUrlFieldRules("Weekly Report Source")}
      >
        <Input placeholder="Paste the Zoho Analytics dashboard link" />
      </Form.Item>
      <Form.Item
        name="monthlyReportLink"
        label="Monthly Report Source"
        rules={getUrlFieldRules("Monthly Report Source")}
      >
        <Input placeholder="Paste the Zoho Analytics dashboard link" />
      </Form.Item>
      <Form.Item
        name="dashboardReportLink"
        label="Dashboard Report Source"
        rules={getUrlFieldRules("Dashboard Report Source")}
      >
        <Input placeholder="Paste the Zoho Analytics dashboard link" />
      </Form.Item>
    </Form>
  );
};
